import type DataResponse from '@/types/DataResponse'
import type PaginatedResponse from '@/types/PaginatedResponse'
import type { AxiosResponse } from 'axios'

export default abstract class ModelService<T> {
  abstract index(page: number, filters: string, per_page: number | undefined): Promise<AxiosResponse<PaginatedResponse<T>>>
  abstract show(id: string): Promise<AxiosResponse<DataResponse<T>>>
  abstract store(model: T): Promise<AxiosResponse<DataResponse<T>>>
  abstract update(id: string, model: T): Promise<AxiosResponse<DataResponse<T>>>
  abstract destroy(model: T): Promise<AxiosResponse>
}
